<div *ngIf="isLoading; else content">
    <div class="wrapper-spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>
<ng-template #content>
    <div class="wrapper">
        <mat-card class="form-card text-center mat-elevation-z6">
            <form [formGroup]="passwordResetForm">
                <app-auth-top [title]="'Zmiana hasła'"
                              [subTitle]="'Wypełni formularz by zmienić hasło'"></app-auth-top>
                <mat-card-content>
                    <mat-form-field class="full-width pt-1" appearance="outline">
                        <mat-label>e-mail</mat-label>
                        <input matInput [formControl]="emailFormControl">
                    </mat-form-field>
                    <mat-form-field class="full-width pt-1" appearance="outline">
                        <mat-label>nowe hasło</mat-label>
                        <input matInput formControlName="password" name="password" type="password"
                               placeholder="nowe hasło" #passwd>
                        <mat-hint align="end">
                            {{ passwd.value.length }} / {{ passwordMaxLength }}
                        </mat-hint>
                        <mat-error *ngIf="password.errors?.['required']">
                            Podaj nowe hasło.
                        </mat-error>
                        <mat-error *ngIf="passwd.value.length < passwordMinLength && !password.errors?.['required']">
                            Minimalna długość hasła wynosi: {{ passwordMinLength }} znaków.
                        </mat-error>
                        <mat-error *ngIf="passwd.value.length > passwordMaxLength">
                            Maksymalna długość hasła wynosi: {{ passwordMaxLength }} znaków.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width pt-1" appearance="outline">
                        <mat-label>powtórz nowe hasło</mat-label>
                        <input matInput formControlName="password_confirmation" name="password_confirmation"
                               type="password" placeholder="powtórz nowe hasło">
                        <mat-error *ngIf="password_confirmation.errors?.['required']">
                            Podaj nowe hasło by sprawdzić poprawność.
                        </mat-error>
                        <mat-error
                            *ngIf="password_confirmation.errors?.['confirmedValidator'] || password_confirmation.errors?.['touched']">
                            Hasła nie pasują do siebie.
                        </mat-error>
                    </mat-form-field>
                    <div class="pt-3">
                        <button type="button" class="full-width" mat-raised-button color="primary"
                                [disabled]="passwordResetForm.invalid"
                                matTooltip="Zapisz nowe hasło" matTooltipPosition="above" (click)="passwordReset()">
                            Zapisz <i class="fa-solid fa-floppy-disk"></i></button>
                    </div>
                </mat-card-content>
                <div class="py-4">
                    <span>Jeżeli nie chcesz zmieniać hasła wróć do </span>
                    <a class="link-secondary" routerLink="/admin"
                       matTooltip="Wróć do logowania" matTooltipPosition="right">logowania</a><span>.</span>
                </div>
            </form>
        </mat-card>
        <div class="mt-2">
            <app-company-link></app-company-link>
        </div>
    </div>
</ng-template>
